class DarkrimMegaMenu extends HTMLElement {
  /** @type {HTMLButtonElement[]} */
  #tabs = [];
  /** @type {HTMLElement[]} */
  #panels = [];

  connectedCallback() {
    this.#tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.#panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

    if (this.#tabs.length === 0) return;

    this.addEventListener('pointerover', this.#handlePointerOver);
    this.addEventListener('focusin', this.#handleFocusIn);
    this.addEventListener('keydown', this.#handleKeydown);
  }

  disconnectedCallback() {
    this.removeEventListener('pointerover', this.#handlePointerOver);
    this.removeEventListener('focusin', this.#handleFocusIn);
    this.removeEventListener('keydown', this.#handleKeydown);
  }

  /**
   * @param {PointerEvent} event
   */
  #handlePointerOver = (event) => {
    if (!(event.target instanceof Element)) return;

    const tab = event.target.closest('[role="tab"]');
    if (!(tab instanceof HTMLButtonElement) || !this.contains(tab)) return;

    this.#select(this.#tabs.indexOf(tab));
  };

  /**
   * @param {FocusEvent} event
   */
  #handleFocusIn = (event) => {
    if (!(event.target instanceof Element)) return;

    const tab = event.target.closest('[role="tab"]');
    if (!(tab instanceof HTMLButtonElement) || !this.contains(tab)) return;

    this.#select(this.#tabs.indexOf(tab));
  };

  /**
   * @param {KeyboardEvent} event
   */
  #handleKeydown = (event) => {
    if (!(event.target instanceof Element)) return;

    const tab = event.target.closest('[role="tab"]');
    if (!(tab instanceof HTMLButtonElement) || !this.contains(tab)) return;

    const currentIndex = this.#tabs.indexOf(tab);
    let nextIndex = currentIndex;

    if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
      nextIndex = (currentIndex + 1) % this.#tabs.length;
    } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
      nextIndex = (currentIndex - 1 + this.#tabs.length) % this.#tabs.length;
    } else if (event.key === 'Home') {
      nextIndex = 0;
    } else if (event.key === 'End') {
      nextIndex = this.#tabs.length - 1;
    } else {
      return;
    }

    event.preventDefault();
    this.#select(nextIndex, true);
  };

  /**
   * @param {number} index
   * @param {boolean} [focus=false]
   */
  #select(index, focus = false) {
    if (index < 0 || index >= this.#tabs.length) return;

    this.#tabs.forEach((tab, tabIndex) => {
      const selected = tabIndex === index;
      tab.setAttribute('aria-selected', String(selected));
      tab.tabIndex = selected ? 0 : -1;
      if (selected && focus) tab.focus();
    });

    this.#panels.forEach((panel, panelIndex) => {
      panel.hidden = panelIndex !== index;
    });

    this.#syncHeaderHeight();
  }

  #syncHeaderHeight() {
    const submenu = this.closest('[ref="submenu[]"]');
    const header = this.closest('header-component');
    if (!(submenu instanceof HTMLElement) || !(header instanceof HTMLElement)) return;

    requestAnimationFrame(() => {
      const submenuHeight = submenu.offsetHeight;
      if (submenuHeight <= 0) return;

      const topRow = header.querySelector('.header__row--top');
      const headerVisibleHeight =
        topRow instanceof HTMLElement ? topRow.offsetHeight : header.offsetHeight;

      header.style.setProperty('--submenu-height', `${submenuHeight}px`);
      header.style.setProperty('--full-open-header-height', `${submenuHeight + headerVisibleHeight}px`);
    });
  }
}

if (!customElements.get('darkrim-mega-menu')) {
  customElements.define('darkrim-mega-menu', DarkrimMegaMenu);
}
